document.addEventListener('DOMContentLoaded', function() {
  
  var carousels = document.querySelectorAll('.fancy-slider');

  carousels.forEach(function(slider) {

    if(slider.children.length == 1){
      return false;
    }
    
    var flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      wrapAround: true,
      pageDots: false
    });

    // Function to set button top position
    function setButtonTop() {
      var slideImage = slider.querySelector('.fancy-slide-image');

      if (slideImage) {
        var height = slideImage.offsetHeight;
        if (height > 0) {
          var middle = height / 2;
          var buttons = slider.querySelectorAll('.flickity-prev-next-button');

          // Set the top value for each button
          buttons.forEach(function(button) {
            button.style.top = middle + 'px';
          });

          console.log('Applied top position to buttons:', middle);
        } else {
          console.log('Height of .fancy-slide-image is still 0.');
        }
      } else {
        console.log('.fancy-slide-image not found.');
      }
    }

    // Wait for Flickity to be ready, then set button positions
    flkty.on('ready', function() {
      setButtonTop();
      console.log('Flickity is ready');
    });

    // Ensure the buttons are positioned after a short delay, if needed
    flkty.on('select', function() {
      setTimeout(setButtonTop, 100); // Adjust as needed
    });

    // Resizing the Flickity instance if needed
    if (flkty) {
      setTimeout(function() {
        flkty.resize();
      }, 500);
    }

    // Set up custom button event listeners
    var buttons = slider.closest('section').querySelectorAll('.fancy-slider-buttons button');

    if (buttons.length > 0) {
      Array.from(buttons).forEach(function(button, index) {
        button.addEventListener('click', function(event) {
          buttons.forEach(function(btn) {
            btn.classList.remove('active');
          });
          event.target.classList.add('active');

          const buttonGroup = buttons[0].parentElement;
          const activeButton = event.target;
          const buttonRect = activeButton.getBoundingClientRect();
          const groupRect = buttonGroup.getBoundingClientRect();
          const translateX = buttonRect.left - groupRect.left;
          buttonGroup.style.setProperty('--active-transform', `translateX(${translateX}px)`);

          flkty.select(index);
        });
      });

      // Change active class on slide change
      flkty.on('select', function() {
        var index = flkty.selectedIndex;
        buttons.forEach(function(btn) {
          btn.classList.remove('active');
        });
        buttons[index].classList.add('active');

        // Update the active transform for the indicator
        const activeButton = buttons[index];
        const buttonGroup = buttons[0].parentElement;
        const buttonRect = activeButton.getBoundingClientRect();
        const groupRect = buttonGroup.getBoundingClientRect();
        const translateX = buttonRect.left - groupRect.left;
        buttonGroup.style.setProperty('--active-transform', `translateX(${translateX}px)`);
      });
    }
  });
  

  document.addEventListener("shopify:section:load", function(event) {
    
    var newSection = event.target;
    var newSlider = newSection.querySelector('.fancy-slider');

    if (newSlider) {
      
      var newFlkty = new Flickity(newSlider, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
      });
      
      newFlkty.resize();

      var newButtons = newSection.querySelectorAll('.fancy-slider-buttons button');
      
      if (newButtons.length > 0) {
        Array.from(newButtons).forEach(function(button) {
          button.addEventListener('click', function(event) {
            var index = Array.from(newButtons).indexOf(event.target);
            newFlkty.select(index);
          });
        });
      }
      
    }
    
  });



  const sidebar = document.querySelector('.richtext-sidebar');
  const faqSection = document.querySelector('.section-wrapper.faq-section');
  const container = document.querySelector('.section-wrapper.has-sidebar > .container');
  const pageSizeGuide = document.querySelector('.page-size-guide');
  function moveSidebar() {
      if (window.innerWidth <= 767) {
          if (faqSection && sidebar && !faqSection.contains(sidebar)) {
              faqSection.parentNode.insertBefore(sidebar, faqSection.nextSibling);
          } else if(pageSizeGuide){
              pageSizeGuide.appendChild(sidebar);
          }
      } else {
          if (container && sidebar && !container.contains(sidebar)) {
              container.insertBefore(sidebar, container.firstChild);
          }
      }
  }

  // Initial check
  moveSidebar();

  // Re-check on window resize
  window.addEventListener('resize', moveSidebar);

  // Utility to find elements within a pendant wrapper
  function getPendantElements(wrapper) {
      return {
          checkbox: wrapper.querySelector('input[type="checkbox"]'),
          pQty: wrapper.querySelector('.p-qty'),
          quantityInput: wrapper.querySelector('.p-qty .quantity-input'),
          price: parseFloat(wrapper.dataset.price || 0)
      };
  }
  
  // Toggle quantity input state
  function toggleQuantityInput(checkbox, wrapper) {
      const { pQty, quantityInput } = getPendantElements(wrapper);
      if (checkbox.checked) {
          setTimeout(() => {
              if (quantityInput.value == 0) quantityInput.value = 1;
          }, 100);
          pQty.classList.remove('disabled');
          // quantityInput.removeAttribute('disabled');
      } else {
          quantityInput.value = 0;
          pQty.classList.add('disabled');
          // quantityInput.setAttribute('disabled', 'disabled');
      }
  }
  
  // Initialize checkbox change events
  function initCheckboxListeners() {
      document.querySelectorAll('.pendant-title input[type="checkbox"]').forEach(checkbox => {
          checkbox.addEventListener('change', function () {
              const pendantWrapper = this.closest('.pendant-wrapper');
              toggleQuantityInput(this, pendantWrapper);
              calculateTotal();
          });
      });
  }
  
  // Increment quantity and ensure checkbox is checked
  function handleIncrement(button) {
      const pendantWrapper = button.closest('.pendant-wrapper');
      const { checkbox, quantityInput } = getPendantElements(pendantWrapper);
  
      if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change'));
      }
  }
  
  // Initialize increment button events
  function initIncrementListeners() {
      document.querySelectorAll('.pendants-wrapper .quantity-button[data-quantity-increment]').forEach(button => {
          button.addEventListener('click', function () {
              handleIncrement(this);
              calculateTotal();
          });
      });
  }
  
  // Decrement quantity and uncheck checkbox if necessary
  function handleDecrement(button) {
      const pendantWrapper = button.closest('.pendant-wrapper');
      const { checkbox, quantityInput } = getPendantElements(pendantWrapper);
  
      if (quantityInput && checkbox) {
          const currentValue = parseInt(quantityInput.value, 10) || 0;
          const newValue = Math.max(currentValue - 1, 0);
          if (newValue === 0) {
              checkbox.checked = false;
              checkbox.dispatchEvent(new Event('change'));
          }
      }
  }
  
  // Initialize decrement button events
  function initDecrementListeners() {
      document.querySelectorAll('.pendants-wrapper .quantity-button[data-quantity-decrement]').forEach(button => {
          button.addEventListener('click', function () {
              handleDecrement(this);
              calculateTotal();
          });
      });
  }

  
  // Initialize all listeners
  function initPendantHandlers() {
      initCheckboxListeners();
      initIncrementListeners();
      initDecrementListeners();
  }

  function calculateTotal() {
    setTimeout(function(){
      let total = 0;
      document.querySelectorAll('.pendant-wrapper').forEach(wrapper => {
          const { quantityInput, price } = getPendantElements(wrapper);
          const quantity = parseInt(quantityInput.value, 10) || 0;
          total += quantity * price;
      });
      const totalElement = document.querySelector('#pendant-total');
      if (totalElement) {
          totalElement.textContent = Shopify.formatMoney(total, moneyFormat);
      }
    },200);
  }

  initPendantHandlers();

  $(".pendant-acc-trigger").on('click', function(){
      $(this).toggleClass('is-active');
      $(".pendant-acc-content").css("display", "flex").hide().fadeIn();
  });

  $("#closependant").on('click', function(){
      $(".pendant-acc-trigger").removeClass('is-active');
      $(".pendant-acc-content").fadeOut();
  });


   $(".button-add-selected").on("click", function () {
        const button = $(this);
        button.addClass("loading");
        setTimeout(() => {
            button.removeClass("loading");
            $(".pendant-acc-content").fadeOut();
            updateSelected();
            $(".pendant-acc-trigger").removeClass('is-active');
        }, 1000);
        checkQuantities();
    });

  function checkQuantities() {
      const quantityInputs = document.querySelectorAll('.pendants-wrapper .p-qty .quantity-input');
      let hasItemWithQuantity = false;
      console.log(quantityInputs);
      for (let input of quantityInputs) {
          if (parseInt(input.value) > 0) {
              $(".product__wrapper.pdp-template-pendant").addClass('isface-selected');
              hasItemWithQuantity = true;
              break;
          }
      }
      
      // Else part: handle when no items have quantity > 0
      if (!hasItemWithQuantity) {
           $(".product__wrapper.pdp-template-pendant").removeClass('isface-selected');
      }
  }

    function updateSelected() {
        let selectedTexts = [];
        $('.pendant-title input[type="checkbox"]:checked').each(function () {
            const label = $(this).closest("label");
            const pendantName = label.find(".pendant-name").text();
            selectedTexts.push(pendantName);
        });
        const triggerH4 = $(".pendant-acc-trigger h4");
        if (selectedTexts.length > 0) {
            triggerH4.text(selectedTexts.join(", "));
        } else {
            triggerH4.text("Select Pendant");
        }
    }




function convertSelectToCustom(selectElement) {
    // Check if a custom dropdown already exists within the same parent
    if (selectElement.parentNode.querySelector(".custom-select")) {
        return; // Prevent duplication
    }

    const customSelect = document.createElement("div");
    customSelect.className = "custom-select";

    const selectedOption = document.createElement("div");
    selectedOption.className = "selected-option";
    selectedOption.textContent = selectElement.options[selectElement.selectedIndex].text;

    const optionsList = document.createElement("ul");
    optionsList.className = "options";

    for (let option of selectElement.options) {
        const listItem = document.createElement("li");
        listItem.textContent = option.text;
        listItem.setAttribute("data-value", option.value);

        listItem.addEventListener("click", function () {
            selectedOption.textContent = this.textContent;
            selectElement.value = this.getAttribute("data-value");
            customSelect.classList.remove("active");

            selectElement.dispatchEvent(new Event("change"));
        });

        optionsList.appendChild(listItem);
    }

    selectedOption.addEventListener("click", function (event) {
        event.stopPropagation(); // Prevent event bubbling
        customSelect.classList.toggle("active");
    });

    document.addEventListener("click", function (event) {
        document.querySelectorAll(".custom-select").forEach(el => {
            if (!el.contains(event.target)) {
                el.classList.remove("active");
            }
        });
    });

    customSelect.appendChild(selectedOption);
    customSelect.appendChild(optionsList);
    
    // Insert before the select element
    selectElement.parentNode.insertBefore(customSelect, selectElement);

    // Hide the original select to avoid duplication issues
    selectElement.style.display = "none";
}



  document.querySelectorAll(".custom-dropdown").forEach(convertSelectToCustom);


function complementarySider() {
    const complementarySection = document.querySelector(".complimantry");
    if (!complementarySection) return; // Exit if section doesn't exist

    // Destroy existing Flickity instance if it exists
    let existingInstance = Flickity.data(complementarySection);
    if (existingInstance) {
        existingInstance.destroy();
    }

    const complementaryCards = complementarySection.querySelectorAll(".complementary-card");

    if (complementaryCards.length > 1) {
        // Clone the last slide
        const lastSlide = complementaryCards[complementaryCards.length - 1].cloneNode(true);
        lastSlide.classList.add("cloned-slide"); // Add a class for styling
        complementarySection.appendChild(lastSlide); // Append it to the slider

        let flickBetter = new Flickity(complementarySection, {
            prevNextButtons: false, // Disable default Flickity buttons
            cellAlign: 'left',
            wrapAround: false,
            contain: true,
            pageDots: false
        });

        // Select custom buttons
        const prevButton = document.querySelector(".comp-nav.comp-prev");
        const nextButton = document.querySelector(".comp-nav.comp-next");

        function updateNavButtons() {
            if (prevButton) {
                prevButton.style.opacity = flickBetter.selectedIndex === 0 ? "0.56" : "1";
                prevButton.style.pointerEvents = flickBetter.selectedIndex === 0 ? "none" : "auto";
            }
        }

        if (prevButton && nextButton) {
            prevButton.addEventListener("click", function () {
                flickBetter.previous();
            });

            nextButton.addEventListener("click", function () {
                if (flickBetter.selectedIndex < complementaryCards.length - 1) { // Prevent selecting cloned slide
                    flickBetter.next();
                }
            });

            flickBetter.on("change", updateNavButtons);
            updateNavButtons();
        }
    }
}




  complementarySider();

  document.addEventListener("cart:updated", function (event) {
    setTimeout(() => {
        complementarySider();
        document.querySelectorAll(".custom-dropdown").forEach(convertSelectToCustom);
        compatc();
    }, 100); 
  });


  function compatc(){
        document.querySelectorAll(".complementary-card button").forEach(button => {
          button.addEventListener("click", function() {
              let select = this.previousElementSibling;
              let variantId = select.value;
              
              if (select && select.tagName === "SELECT" && variantId !== '') {
                  this.classList.add("is-loading");
                  
                  // Create form data with the variant ID and quantity
                  const formData = new FormData();
                  formData.append('id', variantId);
                  formData.append('quantity', 1);
                  
                  // Get cart section ID
                  let sectionId = 'ajax-cart';
                  let cartDrawer = document.querySelector('[data-cart-drawer]');
                  
                  if (cartDrawer) {
                      let cartSection = cartDrawer.querySelector('[data-cart-wrapper]');
                      if (cartSection) {
                          sectionId = cartSection.dataset.section;
                      }
                  }
                  
                  // Add section ID to form data
                  formData.append('sections', [sectionId]);
      
                  // Configuration for the fetch request
                  const config = {
                      method: 'POST',
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/javascript'
                      },
                      body: formData
                  };
      
                  // Make the request
                  fetch('/cart/add.js', config)
                      .then(response => response.text())
                      .then(state => {
                          const cart = JSON.parse(state);
                          
                          if (cart.status && cart.errors) {
                              console.error("Cart errors:", cart.errors);
                              // Handle errors - you might want to show these to the user
                              return;
                          }
      
                          // Update cart drawer
                          if (cartDrawer && cart.sections[sectionId]) {
                              let updatedCartHtml = new DOMParser()
                                  .parseFromString(cart.sections[sectionId], 'text/html')
                                  .querySelector('.shopify-section');
                                  
                              let updatedCartContent = updatedCartHtml.querySelector('[data-cart-wrapper]');
                              let cartbody = cartDrawer.querySelector('[data-cart-drawer-body]');
                              
                              // Update cart content
                              cartbody.innerHTML = updatedCartHtml.innerHTML;
                              document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cartData: cart } }));
                              // Update cart count in header if it exists
                              let cartItemCount = parseInt(updatedCartContent.getAttribute('data-item-count'));
                              if (document.querySelector('[data-header-cart-count]')) {
                                  document.querySelector('[data-header-cart-count]').innerHTML = cartItemCount;
                              }
                              
                              // Show cart drawer
                              document.querySelector('body').classList.add('no-scroll');
                              cartDrawer.classList.add('sd-sidebar--visible');
                              
                              // Update quantity elements and remove buttons if needed
                              if (cartItemCount > 0) {
                                  getQuantityElement(cartDrawer);
                                  getCartItemRemoveElements(cartDrawer);
                              }
                              
                              // Update cart count
                              cartCountUpdate(cartItemCount);
                              
                              // Initialize cart note if needed
                              cartNoteDrawerInt(cartDrawer);
                              cartNoteUpdate();
                          }
                      })
                      .catch(error => {
                          console.error("Error adding to cart:", error);
                          // You might want to show an error message to the user
                      })
                      .finally(() => {
                          this.classList.remove("is-loading");
                      });
              }
          });
      });
  }


  compatc();


    
});



document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".custom-dropdown").forEach(function (dropdown) {
        dropdown.addEventListener("change", function () {
            let selectedValue = this.value; // Get selected value from dropdown
            let dataFor = this.getAttribute("data-for"); // Get the 'data-for' attribute
            let checkbox = document.querySelector(`input[name="${dataFor}"][value="${selectedValue}"]`);
            console.log(checkbox);
            if (checkbox) {
                checkbox.checked = true;
            }
           checkbox.dispatchEvent(new Event("change"));
        });
        
    });
});


const _handleDeleteButtonClick = (event) => {
  event.preventDefault(); // Prevent the default link action

  const currentTarget = event.currentTarget;
  const confirmMessage = currentTarget.getAttribute("data-confirm-message");

  // Confirm before deleting
  if (confirm(confirmMessage)) {
    deleteAddr(currentTarget.getAttribute("data-target"), {
      parameters: { _method: "delete" },
    });
  }
};

// Attach event listener
document.addEventListener("DOMContentLoaded", () => {
  
  document.querySelectorAll(".edit_acc.delete_acc").forEach(button => {
    button.addEventListener("click", _handleDeleteButtonClick);
  });
  
  
});

function initializeSwiper() {
  const sliderWrapper = document.querySelector('.slider-wrapper');

  if (!sliderWrapper) {
    console.error("Slider wrapper not found.");
    return;
  }

  const sliderItem = sliderWrapper.querySelector('.slider-item');
  if (!sliderItem) {
    console.error("Slider item not found.");
    return;
  }

  // Create Swiper wrapper
  const swiperWrapper = document.createElement('div');
  swiperWrapper.classList.add('swiper-wrapper');

  // Move each product image into its own slide
  const images = sliderItem.querySelectorAll('.product-image');
  if (images.length === 0) {
    console.error("No product images found inside .slider-item.");
    return;
  }

  images.forEach(img => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    slide.appendChild(img); // Move image inside slide
    swiperWrapper.appendChild(slide);
  });

  // Clear existing content and insert the new Swiper structure
  sliderWrapper.removeChild(sliderItem); // ✅ Remove old content
  sliderWrapper.appendChild(swiperWrapper);

  // Add Swiper scrollbar
  const scrollbar = document.createElement('div');
  scrollbar.classList.add('swiper-scrollbar');
  sliderWrapper.appendChild(scrollbar);

  // Initialize Swiper with scrollbar only
  new Swiper('.slider-wrapper', { 
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    spaceBetween: 10,
    autoHeight: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    }
  });

}

document.addEventListener("DOMContentLoaded", function(){
  if(window.outerWidth < 490){
    initializeSwiper();
  }
});


function deleteAddr(path, options) {
  options = options || {};
  var method = options["method"] || "POST";
  var params = options["parameters"] || {};

  fetch(path, {
    method: method.toUpperCase(), // Ensure method is uppercase
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(params).toString(),
    credentials: "same-origin", // Ensures cookies (like session authentication) are sent
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Request failed: ${response.statusText}`);
      }
      return response.text();
    })
    .then(() => {
      // Handle successful response (e.g., refresh or update UI)
      console.log("Address deleted successfully!");
      location.reload(); // Reload the page or update UI dynamically
    })
    .catch(error => console.error("Error:", error));
};
